import { useState, useMemo } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import FilterBar from "../../lib/components/Filterbar/Filterbar";
import LogManager from "./LogManager";
import { useGlobalFilters } from "../../lib/context/GlobalFilterProvider";
import ChargerDisplay from "../../lib/components/ChargerDisplay";

export default function LogsDownload() {
  const [selectedTab, setSelectedTab] = useState(0);
  const { serialNumber } = useGlobalFilters();

  const tabOptions = useMemo(
    () => [
      {
        title: "Log Manager",
        content: LogManager,
      },
    ],
    []
  );

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const SelectedContent = tabOptions[selectedTab]?.content;

  return (
    <div className="w-full h-screen overflow-scroll p-8">
      <h1 className="text-2xl font-bold mb-2">Troubleshoot</h1>
      <FilterBar isDatePickerRequired={false} />
      <ChargerDisplay serialNumber={serialNumber} showSidePanel={false} />
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          sx={{
            "& .MuiTab-root": {
              color: "#000",
              "&.Mui-selected": {
                color: "#000",
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#000",
            },
          }}
        >
          {tabOptions.map((tab, index) => (
            <Tab key={index} label={tab.title} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ mt: 3 }}>{SelectedContent && <SelectedContent serialNumber={serialNumber} />}</Box>
    </div>
  );
}
